import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useEffect } from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

var Content = function Content(_ref) {
  var _rest$selectProps;

  var scheduleUpdate = _ref.scheduleUpdate,
      styleMenu = _ref.styleMenu,
      rest = _objectWithoutProperties(_ref, ["scheduleUpdate", "styleMenu"]);

  useEffect(function () {
    // trigger popper update on input change PUI-4069
    scheduleUpdate();
  }, [rest === null || rest === void 0 ? void 0 : (_rest$selectProps = rest.selectProps) === null || _rest$selectProps === void 0 ? void 0 : _rest$selectProps.inputValue]);
  return /*#__PURE__*/React.createElement("div", {
    style: styleMenu,
    "data-testid": "combobox-menu"
  }, /*#__PURE__*/React.createElement(components.Menu, rest));
};

Content.propTypes = {
  scheduleUpdate: PropTypes.func,
  styleMenu: PropTypes.any
};

export default Content;
//# sourceMappingURL=Content.js.map
